import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { DeviceProvider } from './contexts/DeviceContext';
import { AuthProvider } from './contexts/AuthContext';
import { getCenterHomePath } from './utils/navigation';
import './styles/index.scss';

// Fetch Interceptor: 401 or 403 -> Redirect to Home
const originalFetch = window.fetch;
window.fetch = async (...args) => {
    try {
        const response = await originalFetch(...args);
        if (response.status === 401 || response.status === 403) {
            const currentPath = window.location.pathname;
            const homePath = getCenterHomePath();
            // 이미 홈이나 로그인 페이지라면 리다이렉트 하지 않음
            // nginx sub-path (/center/) 또는 로컬 개발 (/) 모두 대응
            if (currentPath !== '/' && currentPath !== '/center/' && currentPath !== '/center' && currentPath !== '/login') {
                window.location.href = homePath;
            }
        }
        return response;
    } catch (error) {
        throw error;
    }
};

// 배포 환경에서 /center/ sub-path로 서빙될 때 basename 자동 감지
const basename = window.location.pathname.startsWith('/center') ? '/center' : '/';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <DeviceProvider>
            <AuthProvider>
                <BrowserRouter basename={basename}>
                    <App />
                </BrowserRouter>
            </AuthProvider>
        </DeviceProvider>
    </React.StrictMode>
);
